import script from "./TablesContainer.vue?vue&type=script&setup=true&lang=js"
export * from "./TablesContainer.vue?vue&type=script&setup=true&lang=js"

import "./TablesContainer.vue?vue&type=style&index=0&id=b2e471de&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b2e471de"]])

export default __exports__